module.exports = __webpack_public_path__ + "static/media/me-4.11d574ca.svg";